import { useLocation } from 'react-router-dom';
import React from 'react';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import PortfolioTabs from '../../../portfolio/PortfolioTabs.jsx';
import { PortfolioInfoLink, ProjectsLink } from '../../../links/index.jsx';
import { matchesRoute } from '../../../../helpers/breadcrumbRouteHelpers.js';

const PortfolioHeader = ({ portfolio, portfolioTabs, editing }) => {
  const location = useLocation();

  return (
    <PageHeader
      flex
      navigation={
        portfolioTabs ? <PortfolioTabs portfolioId={portfolio.id} /> : null
      }
    >
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>

        {(matchesRoute(
          location.pathname,
          '/:slug/portfolio/:portfolioId/info'
        ) ||
          matchesRoute(
            location.pathname,
            '/:slug/portfolio/:portfolioId/projects'
          )) &&
        portfolio &&
        !matchesRoute(
          location.pathname,
          '/:slug/portfolio/:portfolioId/edit',
          false
        ) &&
        !matchesRoute(location.pathname, '/:slug/portfolio/new', false) ? (
          <span>{portfolio.name}</span>
        ) : null}

        {matchesRoute(location.pathname, '/:slug/portfolio/new', false) ||
        matchesRoute(
          location.pathname,
          '/:slug/portfolio/:portfolioId/edit',
          false
        ) ||
        matchesRoute(location.pathname, '/:slug/parent-portfolio/new', false) ||
        matchesRoute(
          location.pathname,
          '/:slug/parent-portfolio/:portfolioId/edit',
          false
        ) ? (
          <span>
            {location.pathname.includes('/edit') ? 'Edit' : 'Add'}{' '}
            {location.pathname.includes('parent-portfolio')
              ? getOrgTermsContent('parentPortfolio')
              : getOrgTermsContent('portfolio')}
          </span>
        ) : null}

        {matchesRoute(
          location.pathname,
          '/:slug/portfolio/:portfolioId/settings'
        ) &&
          portfolio && (
            <PortfolioInfoLink portfolioId={portfolio.id}>
              {portfolio.name}
            </PortfolioInfoLink>
          )}
        {matchesRoute(
          location.pathname,
          '/:slug/portfolio/:portfolioId/settings'
        ) &&
          portfolio && <span>Customize {getOrgTermsContent('portfolio')}</span>}
      </BreadCrumbs>
    </PageHeader>
  );
};
export default PortfolioHeader;
